import { useAccessibility } from "../../../../../Store/contexts/AccessibilityContext";
import "./styles.css";

const ExecutiveBenefDataCard: React.FC<{ nome?: string, email?: string, telefone?: string }> = ({ nome, email, telefone }) => {

  const accessibility = useAccessibility();

  return (
    <div className="registration-data-card-holder" >
      <div className="registration-data-card" tabIndex={0} style={{...accessibility.contrastStyle, ...accessibility.contrastBorderAccessibility}}>
        <div className="registration-data-row">
          <span style={accessibility.textStyleAccessibility} className="registration-data-title">Dados do beneficiário</span>
        </div>
        <div className="registration-data-row registration-data-row-secondary" style={{...accessibility.contrastStyle, ...accessibility.contrastBorderAccessibility}}>
          <span style={accessibility.textStyleAccessibility} className="registration-data-key">Nome</span>
          <span style={accessibility.textStyleAccessibility} className="registration-data-value">{nome}</span>
        </div>
        <div className="registration-data-row">
          <span style={accessibility.textStyleAccessibility} className="registration-data-key">Telefone</span>
          <span style={accessibility.textStyleAccessibility} className="registration-data-value">{telefone}</span>
        </div>
        <div className="registration-data-row registration-data-row-secondary radius-bottom" style={{...accessibility.contrastStyle, ...accessibility.contrastBorderAccessibility}}>
          <span style={accessibility.textStyleAccessibility} className="registration-data-key">E-mail</span>
          <span style={accessibility.textStyleAccessibility} className="registration-data-value">{email}</span>
        </div>
      </div>
    </div>
  )
}

export default ExecutiveBenefDataCard;